import React from 'react';

import { Product } from 'models/product';
import { SearchResult } from 'models/search';

import { Carousel } from './view/Carousel';

export const RelatedProducts: React.FC<{
  department: string;
  gridArea: string;
  product: Product;
  products: SearchResult[];
}> = ({ department, product, products, gridArea }) => {
  return (
    <div className="related-products">
      <Carousel department={department} product={product} products={products} />
      <style jsx>{`
        .related-products {
          grid-area: ${gridArea};
          width: 100%;
          border-bottom: 2px solid #efeeef;
        }

        @media (min-width: 1024px) {
          .related-products {
            border: 0;
          }
        }
      `}</style>
    </div>
  );
};
